/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Success_ToastInputs */

const en_iconik_import_success_toast = /** @type {(inputs: Iconik_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project import completed successfully`)
};

const fr_iconik_import_success_toast = /** @type {(inputs: Iconik_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du projet terminee avec succes`)
};

const de_iconik_import_success_toast = /** @type {(inputs: Iconik_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektimport erfolgreich abgeschlossen`)
};

const it_iconik_import_success_toast = /** @type {(inputs: Iconik_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del progetto completata con successo`)
};

const ru_iconik_import_success_toast = /** @type {(inputs: Iconik_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт проекта успешно завершен.`)
};

const es_iconik_import_success_toast = /** @type {(inputs: Iconik_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La importación del proyecto se completó correctamente`)
};

const zh_cn2_iconik_import_success_toast = /** @type {(inputs: Iconik_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目导入已成功完成`)
};

const ja_iconik_import_success_toast = /** @type {(inputs: Iconik_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポートが正常に完了しました`)
};

const hi_iconik_import_success_toast = /** @type {(inputs: Iconik_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट का आयात सफलतापूर्वक पूरा हो गया।`)
};

const pt_pt2_iconik_import_success_toast = /** @type {(inputs: Iconik_Import_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação do projeto concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Project import completed successfully" |
*
* @param {Iconik_Import_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_success_toast = /** @type {((inputs?: Iconik_Import_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_import_success_toast(inputs)
	if (locale === "de") return de_iconik_import_success_toast(inputs)
	if (locale === "it") return it_iconik_import_success_toast(inputs)
	if (locale === "ru") return ru_iconik_import_success_toast(inputs)
	if (locale === "es") return es_iconik_import_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_import_success_toast(inputs)
	if (locale === "ja") return ja_iconik_import_success_toast(inputs)
	if (locale === "hi") return hi_iconik_import_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_import_success_toast(inputs)
	return en_iconik_import_success_toast(inputs)
});